import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UIModule } from './ui/ui.module';

import { WidgetModule } from './widget/widget.module';
import {ReplaceNullWithTextPipe} from "../Modules/Shared/Pipes/replace-null-with-text.pipe";
import { BtnLoadingComponent } from './ui/btn-loading/btn-loading.component';

@NgModule({
  declarations: [
    BtnLoadingComponent,
    ReplaceNullWithTextPipe,
  ],
  imports: [
    CommonModule,
    UIModule,
    WidgetModule
  ],
  exports: [
    BtnLoadingComponent,
    ReplaceNullWithTextPipe,
  ],
})

export class SharedModule { }
